// Cal.com booking modal — lazy-loaded.
//
// On first click of any [data-cal-modal] element, we install Cal.com's
// embed script and open the booking modal in place. Subsequent clicks
// open the modal directly with no further loading. The element keeps
// a working href fallback (target=_blank to cal.com), so visitors with
// JS disabled or behind a script blocker still get to book.
//
// CAL_LINK is the 30-min first chat. A button can book a different
// event by naming it in data-cal-link (e.g. data-cal-link=
// "grantgiles/1-on-1-consultation"); keep its href pointing at the
// same event so the no-JS fallback matches.

const CAL_LINK = "grantgiles/athlete-30-minutes-first-chat";
const CAL_LINK_PATTERN = /^grantgiles\/[a-z0-9-]+$/;
const CAL_NAMESPACE = "athlete-chat";
const CAL_SCRIPT_SRC = "https://app.cal.com/embed/embed.js";

// Brand colours intentionally NOT overridden here. The single source
// of truth lives in cal.com → Settings → Appearance → Custom brand
// colors. Whatever's set there flows through to the modal via the
// embed iframe — keeps the standalone cal.com page and the modal in
// step with one config edit.

let initialised = false;

function initCal() {
    if (initialised) return;

    /* eslint-disable */
    // Cal.com's official inline loader. Creates a window.Cal shim that
    // queues commands, injects embed.js on first invocation, and
    // replays the queue once the script loads.
    (function (C, A, L) {
        let p = function (a, ar) { a.q.push(ar); };
        let d = C.document;
        C.Cal = C.Cal || function () {
            let cal = C.Cal;
            let ar = arguments;
            if (!cal.loaded) {
                cal.ns = {};
                cal.q = cal.q || [];
                d.head.appendChild(d.createElement("script")).src = A;
                cal.loaded = true;
            }
            if (ar[0] === L) {
                const api = function () { p(api, arguments); };
                const namespace = ar[1];
                api.q = api.q || [];
                typeof namespace === "string"
                    ? (cal.ns[namespace] = api) && p(api, ar)
                    : p(cal, ar);
                return;
            }
            p(cal, ar);
        };
    })(window, CAL_SCRIPT_SRC, "init");
    /* eslint-enable */

    window.Cal("init", CAL_NAMESPACE, { origin: "https://cal.com" });
    window.Cal.ns[CAL_NAMESPACE]("ui", {
        theme: "light",
        hideEventTypeDetails: false,
        layout: "month_view",
    });

    initialised = true;
}

// Where the booking came from, attached to the booking as Cal.com
// metadata. A ?from=… URL param (e.g. a social link) wins over the
// button's data-cal-source, which marks the page the button sits on.
function bookingSource(btn) {
    let from = "";
    try {
        from = new URLSearchParams(window.location.search).get("from") || "";
    } catch {
        /* older browsers — fall back to the button's source */
    }
    return (from || btn.dataset.calSource || "").slice(0, 40); // defensive cap
}

// The event this button books. Anything that isn't one of Grant's
// event links falls back to the first chat.
function bookingLink(btn) {
    const link = btn.dataset.calLink || "";
    return CAL_LINK_PATTERN.test(link) ? link : CAL_LINK;
}

function openModal(link, source) {
    const config = { layout: "month_view" };
    if (source) config["metadata[source]"] = source;
    window.Cal.ns[CAL_NAMESPACE]("modal", {
        calLink: link,
        config,
    });
}

export default function cal() {
    const buttons = document.querySelectorAll("[data-cal-modal]");
    if (!buttons.length) return;

    buttons.forEach((btn) => {
        btn.addEventListener("click", (event) => {
            // Only intercept plain left-clicks. Modifier-clicks
            // (cmd-click, middle-click) keep the native fallback so
            // power users can open cal.com in a new tab.
            if (
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey ||
                event.button !== 0
            ) {
                return;
            }
            event.preventDefault();
            initCal();
            openModal(bookingLink(btn), bookingSource(btn));
        });
    });
}
